<ion-card class="number-card {{cssClass}}">
  <ion-label class="number-card-label ion-text-uppercase">{{ label }}</ion-label>
  <ion-label class="number-card-value">{{ value }}</ion-label>
</ion-card>